import * as Sentry from "@sentry/react";

let installed = false;

export function installSentryAxiosInterceptor(axiosInstance) {
  if (installed || !axiosInstance) return;
  installed = true;

  axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
      const status = err?.response?.status;
      const method = (err?.config?.method || "GET").toUpperCase();
      const path = (err?.config?.url || "").split("?")[0];

      if (!status || status >= 500) {
        Sentry.withScope((scope) => {
          scope.setTag("http.status", String(status || "NA"));
          scope.setTag("http.method", method);
          scope.setContext("request", { url: path });
          Sentry.captureException(err);
        });
      }
      return Promise.reject(err);
    }
  );
}
